import { KeyboardDatePicker } from '@material-ui/pickers'
// import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date'
import CalendarMonthOutlineIcon from 'mdi-react/CalendarMonthOutlineIcon'
import LeftIcon from 'mdi-react/ChevronLeftIcon'
import RightIcon from 'mdi-react/ChevronRightIcon'
import { useState, useEffect } from 'react'
// import CalendarIcon from '../../../images/CalendarIcon.svg'
import { getCurrentLanguage } from '../../../translations/i18n'
import { formatMoment } from '../../../utils/dates'
// import { formatDateToUtc } from '../../../utils/dates'
// import styles from './styles.module.css'

// const cancelLabel = {
//   en: 'cancel',
//   fi: 'peruuta'
// }

interface ReduxPickerProps {
  input: { value: string | Date | undefined; onChange: any; onBlur: any }
  label: string
  invalidLabel: string
  meta: any
  [key: string]: any
}

/** Used to connect redux forms with mui/pickers date picker */
const ReduxPicker = ({
  input: { onChange, value, onBlur },
  label,
  invalidLabel,
  meta: { touched, invalid, error },
  ...custom
}: ReduxPickerProps) => {
  const [locale, setLocale] = useState<string>(getCurrentLanguage())
  const [isOpen, setIsOpen] = useState(false)
  //   const [selectedDate, setSelectedDate] = useState<
  //     Date | MaterialUiPickersDate | null
  //   >(new Date('2014-08-18T21:11:54'))

  //   const handleDateChange = (date: Date | MaterialUiPickersDate | null) => {
  //     setSelectedDate(date)
  //   }

  useEffect(() => {
    const currentLocale = getCurrentLanguage()
    setLocale(currentLocale)
  }, [locale, setLocale])
  return (
    // <DatePicker
    //   label={label}
    //   invalidLabel={invalidLabel}
    //   cancelLabel={cancelLabel[locale]}
    //   format='DD.MM.YYYY'
    //   leftArrowIcon={<LeftIcon />}
    //   rightArrowIcon={<RightIcon />}
    //   helperText={invalid && touched ? error : undefined}
    //   error={invalid && touched}
    //   value={value || null}
    //   onClose={() => onBlur()}
    //   onChange={(momentValue) =>
    //     onChange(formatMoment(momentValue, 'YYYY-MM-DD'))
    //   }
    //   {...custom}
    // />
    <KeyboardDatePicker
      autoOk={true}
      disablePast
      label={label}
      disableToolbar
      variant='inline'
      format='DD.MM.YYYY'
      margin='normal'
      id='date-picker-inline'
      inputVariant='standard'
      value={value || null}
      helperText={invalid && touched ? error : undefined}
      error={invalid && touched}
      leftArrowIcon={<LeftIcon />}
      rightArrowIcon={<RightIcon />}
      onOpen={() => setIsOpen(true)}
      keyboardIcon={
        <CalendarMonthOutlineIcon
          color={isOpen ? '#4F9B44' : '#9DA9B1'}
          radius={10}
          size={'18px'}
        />
      }
      KeyboardButtonProps={{
        'aria-label': 'change date'
      }}
      onClose={() => {
        onBlur()
        setIsOpen(false)
      }}
      onChange={(momentValue) =>
        onChange(formatMoment(momentValue, 'YYYY-MM-DD'))
      }
      // inputVariant={'standard'}
      {...custom}
    />
  )
}

export default ReduxPicker
